import React from 'react';
import { Chip, ChipProps } from '@mui/material';

interface FilterChipProps extends Omit<ChipProps, 'onDelete'> {
  onDelete?: () => void;
}

const FilterChip: React.FC<FilterChipProps> = (props) => {
  const { onDelete, ...chipProps } = props;
  
  return (
    <Chip
      {...chipProps}
      variant="outlined"
      clickable={!!onDelete}
      onClick={onDelete}
      sx={{
        borderRadius: '4px',
        border: '1px solid #ff4900',
        backgroundColor: 'transparent',
        color: 'text.secondary',
        fontWeight: 400,
        fontSize: '0.875rem',
        '& .MuiChip-label': {
          padding: '4px 8px',
        },
        '& .MuiChip-deleteIcon': {
          display: 'none',
        },
      }}
    />
  );
};

export default FilterChip;
